import { type Node as ProseMirrorNode } from 'prosemirror-model'
import { defaultMarkdownParser, defaultMarkdownSerializer, schema } from 'prosemirror-markdown'
import { exampleSetup } from 'prosemirror-example-setup'
import { InputRule, inputRules } from 'prosemirror-inputrules'
import MarkdownIt from 'markdown-it'

export const markdownSchema = schema
const markdownRenderer = new MarkdownIt({ html: false, breaks: true, linkify: true })

export function parseMarkdown(value: string) {
  return defaultMarkdownParser.parse(value || '')
}

export function serializeMarkdown(doc: ProseMirrorNode) {
  return defaultMarkdownSerializer.serialize(doc)
}

function inlineMarkdownInputRules() {
  const strong = markdownSchema.marks.strong
  const em = markdownSchema.marks.em
  const code = markdownSchema.marks.code
  const link = markdownSchema.marks.link

  return [
    new InputRule(/(^|\s)\*\*([^*\n]+)\*\*$/, (state, match, start, end) => {
      const leading = match[1]
      const content = match[2]
      return state.tr.replaceWith(start + leading.length, end, state.schema.text(content, [strong.create()]))
    }),
    new InputRule(/(^|\s)\*([^*\n]+)\*$/, (state, match, start, end) => {
      const leading = match[1]
      const content = match[2]
      return state.tr.replaceWith(start + leading.length, end, state.schema.text(content, [em.create()]))
    }),
    new InputRule(/(^|\s)_([^_\n]+)_$/, (state, match, start, end) => {
      const leading = match[1]
      const content = match[2]
      return state.tr.replaceWith(start + leading.length, end, state.schema.text(content, [em.create()]))
    }),
    new InputRule(/(^|\s)`([^`\n]+)`$/, (state, match, start, end) => {
      const leading = match[1]
      const content = match[2]
      return state.tr.replaceWith(start + leading.length, end, state.schema.text(content, [code.create()]))
    }),
    new InputRule(/(^|\s)\[([^\]\n]+)\]\((https?:\/\/[^\s)]+|mailto:[^\s)]+)\)$/, (state, match, start, end) => {
      const leading = match[1]
      const content = match[2]
      const href = match[3]
      return state.tr.replaceWith(start + leading.length, end, state.schema.text(content, [link.create({ href })]))
    }),
  ]
}

export function createMarkdownPlugins(options: { disableGapCursor?: boolean } = {}) {
  const plugins = [
    ...exampleSetup({ schema: markdownSchema, menuBar: false, floatingMenu: false }),
    inputRules({ rules: inlineMarkdownInputRules() }),
  ]
  if (!options.disableGapCursor) return plugins
  return plugins.filter(plugin => !((plugin.spec.props as { createSelectionBetween?: unknown } | undefined)?.createSelectionBetween))
}

export function markdownToHtml(value: string) {
  return value.trim() ? markdownRenderer.render(value) : ''
}
